import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { EN } from './resources/en'
import { ES } from './resources/es'

const resources = {
  English: {
    translation: EN
  },
  Spanish: {
    translation: ES
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "English",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
